import { format, formatDistanceStrict } from 'date-fns'
import { momentDate } from 'utils'
import _ from 'lodash'

class Alert {
    constructor(props){
        let updatedProps = props || {}
        this.userID = updatedProps.userID
        this.date = updatedProps.date || new Date()
        this.alertID = updatedProps.alertID
        this.secID = updatedProps.secID // {id: ..., relation: ...}
        this.title = updatedProps.title
        this.subtitle = updatedProps.subtitle
        this.reference = updatedProps.reference || {value: 0, metric: 'minutes'}
    }

    // Format alert date into string
    datetimeString = () => {
        const date = new Date(this.date)
        let type = date.getHours() === 0 & date.getMinutes() === 0 & date.getSeconds() === 0 & date.getMilliseconds() === 0 ? 'day' : 'time'
        const formatString = type === 'item' ? 'yyyy-MM-dd HH:mm:ss'
                    : type === 'day' ? 'eee, MMM d yyyy' 
                    : type === 'time' ? 'eee, MMM d yyy (h:mm aaaa)'
                    : 'yyyy-MM-dd HH:mm:ss'
        let updatedValue = new Date(this.date)
        updatedValue = new Date(updatedValue)
        updatedValue.setSeconds(0,0)
        updatedValue = format(updatedValue, formatString).toString();
        return updatedValue;
    }

    // Convert alert date into relative time string
    alertConverter = (targetDate) => {
        const date = new Date(this.date)
        let type = this.date.getHours() === 0 & this.date.getMinutes() === 0 & this.date.getSeconds() === 0 & this.date.getMilliseconds() === 0 ? 'day' : 'time'
        const options = type === 'day' ? ['weeks', 'days']
                        : type === 'time' ? ['days', 'hours', 'minutes']
                        : null
        const distance = date - targetDate === 0 ? 'At event time' : `${formatDistanceStrict(date, targetDate)} before`
        if(!options){
            return null
        } else {
            // console.log({distance: distance, refDate: refDate, targetDate: targetDate, type: type, options: options})
            return distance
        }
    }


    // Convert alert into relative time string (with timezone)
    getDistance = (targetDate, timezone) => {
        // Get alert date
        let duration = {}
        duration[this.reference['metric']] = this.reference['value']
        const alertDate = targetDate.clone().subtract(duration)

        // Get alert string
        const type = targetDate.hours() === 0 & targetDate.minutes() === 0 & targetDate.seconds() === 0 ? 'day' : 'time'
        const format = type === 'day' ? 'ddd D M Y' : 'ddd D M Y (hmma)'
        const alertString = alertDate.format(format)

        // Get distance string
        const distance = _.isEqual(this.reference, {value: 0, metric: 'minutes'}) ? 'At event time' : `${formatDistanceStrict(alertDate.toDate(), targetDate.toDate())} before`

        return {date: alertDate, distance: distance}
    }
}

export default Alert
